









































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import authApi from '@/api/auth';
import membersApi from '@/api/members';

@Component
export default class ServiceGuideDetails extends Vue {
  get transformBar() {
    return { transform: `translateX(${this.tabIndex * 100}%)` };
  }

  get transformContainer() {
    return { transform: `translateX(${this.tabIndex * -100}%)` };
  }

  @Prop({ required: true, default: 0 })
  tabIndex!: number;

  switchTab(index: number) {
    if (this.tabIndex === index) return;
    this.$router.replace({ name: 'service-guide-details', params: { id: index.toString() } });
  }

  handleClick() {
    this.$router.push({
      name: 'faq'
    });
  }
}
